<template>
  <div class="white-content-table">
    <div
      class="table-responsive"
      @change="consultar"
    >
      <table class="table table-stripped">
        <thead>
          <tr>
            <th width="5%"></th>
            <th>Usuario</th>
            <th>Datos antiguos</th>
            <th>Datos nuevos</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in solicitudes"
            :key="item.id"
            @change="consultar"
          >
            <td>
              <a
                href="javascript:void(0)"
                @click="revisar(item)"
              >
                <i class="ti-eye btn-icon-append"></i> </a
              >&nbsp;
            </td>
            <td>{{ item.usuario.usuario }}</td>
            <td>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr>
                    <td>
                      <div><strong>Nombre:</strong> {{ item.oldData.nombre }}</div>
                      <div><strong>Usuario:</strong> {{ item.oldData.email }}</div>
                      <div><strong>Rol:</strong> {{ item.oldData.rol }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table class="table table-sm table-bordered mb-0">
                <tbody>
                  <tr>
                    <td>
                      <div><strong>Nombre:</strong> {{ item.newData.nombre }}</div>
                      <div><strong>Usuario:</strong> {{ item.newData.email }}</div>
                      <div><strong>Rol:</strong> {{ item.newData.rol }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GestionSolicitudModificacion',
  data() {
    return {};
  },
  created() {
    this.consultar();
  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultar() {
      this.loaderSpinner();
      try {
        await this.$store.dispatch('solicitudModificacion/consultar');
      } catch (error) {
        this.$swal({
          text: 'Error al consultar las solicitudes de modificación',
          icon: 'error',
        });
      } finally {
        this.loader.hide();
      }
    },
    async revisar(item) {
      await this.$store.commit('solicitudModificacion/setSolicitudEdicionSeleccionada', item);
      this.$router.push({ name: 'SolicitudModificacionForm' });
    },
  },
  computed: {
    solicitudes() {
      return this.$store.getters['solicitudModificacion/solicitudesEdicion']
        ? this.$store.getters['solicitudModificacion/solicitudesEdicion']
        : [];
    },
    isLogged() {
      return this.$store.getters['auth/isLogged'] ? this.$store.getters['auth/isLogged'] : false;
    },
  },
};
</script>
